{"browse_shop":"Parcourir la boutique","go_to_shop":"Aller à la boutique","no_orders_found":"Aucune commande trouvée","title":"Commandes"}